import { GetterTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { ActivityTypesRoughState } from './types';

const getters: GetterTree<ActivityTypesRoughState, RootState> = {
  ...subscribableStore.getters,
};

export default getters;
